<app-windowlist [model]="this">
    <div class="card">
            <div class="row">
                <div class="col-9">
                    <div class="input-group input-group-info input-group-sm p-1">
                        <input type="text" name="table_search" class="form-control form-control-sm" placeholder="Cerca per nome modulo" [(ngModel)]="filter_search.value" (keyup.enter)="getItems()" [class.alert-info]="filter_search.value!=''">
                        <div class="input-group-append ">
                            <button type="submit" class="btn btn-default text-primary"  title="avvia ricerca" (click)="getItems()"><i class="fas fa-search"></i></button>
                            <button type="button" class="btn btn-default text-danger" *ngIf="filter_search.value!=''"  title="annulla ricerca" (click)="filter_search.value='';getItems();"><span id="searchclear" class="fas fa-times"></span></button>
                        </div>
                    </div>
                </div>
                <div class="col-3 text-right">
                    <button class="btn btn-success btn-sm m-1" (click)="add()"><i class="fa fa-plus"></i></button>
                </div>
            </div>
            <form [formGroup]="form" *ngIf="list!=null">
                <table class="table table-nowrap  table-sm table-hover m-0 text-sm">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nome</th>
                            <!-- <th>Permessi</th> -->
                            <th class="">Mostra nel menu</th>
                            <th class="text-center">Abilitato</th>                        
                            <th class="text-center">Default</th>
                            <th class="text-center">Ordinamento</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of list" [class.text-gray]="record.status==0">
                            <td class="text-center">
                                <span *ngIf="record.icon"><i class="text-gray {{record.icon}} fa-2x mr-2"></i></span>
                            </td>
                            <td>
                                <span class="pointer" data-toggle="modal" data-target="#modalRule" (click)="setRule(record)"><b>{{record.label}}</b></span>
                                &ensp;/&ensp;
                                <span class="pointer text-gray" data-toggle="modal" data-target="#modalRule" (click)="setRule(record)"><i>{{record.modulename}}</i></span>
                            </td>
                            <!-- <td>
                                <small>{{record.permissions}}</small>
                            </td> -->
                            <td class="">
                                <div *ngIf="record.type==1 || record.type==2" class="badge badge-secondary badge-left px-2">Backend</div>
                                <div *ngIf="record.type==3" class="badge badge-primary px-2">Frontend</div>
                                <div *ngIf="record.type==4" class="badge badge-secondary badge-left px-2">Backend</div>
                                <div *ngIf="record.type==4" class="badge badge-primary badge-right px-2">Frontend</div>
                                <div class="badge bg-gray badge-right">
                                    <small *ngIf="record.type==1">MAIN</small>
                                    <small *ngIf="record.type==2">SETTINGS</small>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="pointer" (click)="setStatusModule(record)">
                                    <i *ngIf="record.status==1" class="fa-2x fa fa-eye text-success" title="Pubblicato"></i>
                                    <i *ngIf="record.status==2" class="fa-2x fa fa-eye text-olive" title="status:2"></i>
                                    <i *ngIf="record.status==0" class="fa-2x fa fa-eye-slash" title="Non pubblicato"></i> 
                                </div>
                            </td>                           
                            <td class="text-center">
                                <div class="pointer" (click)="setDefaultModule(record)">
                                    <i *ngIf="record.defaultmodule" class="fa fa-2x fa-check-square text-success"></i>
                                    <i *ngIf="!record.defaultmodule"  class="far fa-2x fa-square text-gray"></i>
                                </div>
                            </td>
                            <td class="text-center" title="Doppio Click per modificare">
                                <span class="mb-0" *ngIf="!record['orderingEditMode']" (dblclick)="record['orderingEditMode']=true">{{record.ordering}}</span>
                                <div class="form-group form-group-sm mb-0" *ngIf="record['orderingEditMode']">
                                    <div class="input-group input-group-sm">
                                        <input type="form-control form-control-sm text-center" name="ordering" [(ngModel)]="record.ordering" style="width:50px">
                                        <div class="input-group-append input-group-append-sm">
                                            <button class="btn btn-success btn-sm" (click)="update(record);record['orderingEditMode']=false;"><i class="fa fa-check"></i></button>
                                            <button class="btn btn-danger btn-sm" (click)="record['orderingEditMode']=false;"><i class="fa fa-times"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button type="button" title="Modifica" class="btn btn-secondary btn-xs float-right ml-1" data-toggle="modal" data-target="#modalRule" (click)="setRule(record)">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        <div class="card-footer clearfix py-1">
            <!-- <small class="mr-1">Visualizzati <b class="text-primary" style="font-size: 110%;">{{recordcount}}</b> elementi</small> -->
            <app-pagination [model]="this" ></app-pagination>
        </div>
    </div>
</app-windowlist>

     
<div class="modal modal-open fade" id="modalRule" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <b>Dettaglio modulo</b>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-dismiss="modal" >
                      <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="modal-body" *ngIf="selectedModule">
                <div class="row">
                    <div class="col-4">
                        <div class="form-group mb-1">
                            <label>Nome</label>
                            <input class="form-control form-control-sm" type="text" name="modulename" [(ngModel)]="selectedModule.modulename"/>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group mb-1">
                            <label>Etichetta</label>
                            <input class="form-control form-control-sm" type="text" name="label" [(ngModel)]="selectedModule.label"/>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group mb-1">
                            <label>Stato</label>
                            <div class="input-group" >
                                <select name="status" class="form-control form-control-sm" name="status" [(ngModel)]="selectedModule.status">
                                    <option value="0">Non pubblicato</option>
                                    <option value="1">Pubblicato</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="form-group mb-1">
                            <label>Mostra nel menù</label>
                            <div class="input-group" >
                                <select name="type" class="form-control form-control-sm" name="type" [(ngModel)]="selectedModule.type">
                                    <option value="0">No</option>
                                    <option value="1">Backend (sidebar)</option>
                                    <option value="2">Backend (Menu amministrativo)</option>
                                    <option value="4">Backend + Frontend</option>
                                    <option value="3">Frontend</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group mb-1">
                            <label>Icona</label>
                            <div class="input-group input-group-sm">
                                 <div class="input-group-prepend">
                                    <span class="input-group-text bg-white"><i class="{{selectedModule.icon}}"></i></span>
                                </div>
                                <input class="form-control form-control-sm" type="text" name="icon" [(ngModel)]="selectedModule.icon"/>
                            </div>                    
                        </div>
                    </div>
                      <div class="col-2">
                        <div class="form-group mb-1">
                            <label>Ordine</label>
                            <input class="form-control form-control-sm" type="number" name="ordering" [(ngModel)]="selectedModule.ordering"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-1">
                            <label>Permessi di accesso</label><br>
                            <ng-container *ngFor="let ug of usergroups">
                                 <ng-container *ngIf="ug.name!='superuser' || (ug.name=='superuser' && user.role=='superuser')">
                                    <div class="d-inline-block mr-4">
                                        <input class="mr-2" type="checkbox" [checked]="checkPermissions(ug.name)" (click)="setPermissions(ug.name);">
                                        <span>{{ug.title}}</span>
                                    </div>
                                 </ng-container>                               
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="row py-4" *ngIf="isArray(selectedModule.params)">
                    <div class="col-12">
                        <h5>Altri parametri</h5>                   
                        <table class="table table-sm table-striped border">
                        <tbody>
                            <ng-container *ngFor="let p of selectedModule.params">
                                <tr *ngIf="p.type=='separator'">
                                    <td colspan="2"><b>{{p.label}}&ensp;</b></td>
                                </tr>
                                <tr *ngIf="p.type!='separator'">
                                    <td><label>{{p.label}}&ensp;</label></td>
                                    <td>                                    
                                        <div class="input-group input-group-sm" *ngIf="p.type=='type'">
                                            <input type="number" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                            <div class="input-group-append">
                                                <button class="btn btn-default" (click)="searchType(p)"><i class="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                        <div class="input-group input-group-sm" *ngIf="p.type=='notification'">
                                            <input type="number" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                            <div class="input-group-append">
                                                <button class="btn btn-default" (click)="searchNotification(p)"><i class="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                        <div class="input-group input-group-sm" *ngIf="p.type=='notificationrules'">                                        
                                            <table class="table">
                                                <thead>
                                                    <th>Tipologia</th>
                                                    <th>Notifica</th>
                                                    <th>Giorni prima dalla data del record</th>
                                                    <th>Condizione (SQL)</th>
                                                    <th><button type="button" class="btn btn-sm btn-outline-success btn-block" (click)="addNotificationRule(p)"><i class="fa fa-plus"></i></button></th>
                                                </thead>
                                                <tr *ngFor="let r of p.value">
                                                    <td>                                                 
                                                        <select class="form-control form-control-sm" [(ngModel)]="r.type" >                                                        
                                                            <option *ngFor="let t of types" [ngValue]="t.id">{{t.name}}</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select class="form-control form-control-sm" [(ngModel)]="r.notification">                                                        
                                                            <option *ngFor="let n of notifications" [ngValue]="n.id">{{n.name}}</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="number" class="form-control form-control-sm" [(ngModel)]="r.days">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control form-control-sm" [(ngModel)]="r.condition">
                                                    </td>
                                                    <td>
                                                        <button type="button" class="btn btn-sm btn-danger btn-block" (click)="deleteNotificationRule(p,r)"><i class="fa fa-trash"></i></button>
                                                    </td>
                                                </tr>
                                            </table>
                                            
                                        </div>
                                        <input *ngIf="p.type=='number'" type="number" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                        <input *ngIf="p.type=='text'" type="text" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                        <select *ngIf="p.type=='boolean'" class="form-control form-control-sm" name="value" [(ngModel)]="p.value">
                                            <option value="true">Si</option>
                                            <option value="false">No</option>
                                        </select>
                                        <ngx-tags-input *ngIf="p.type=='multiple'" displayField="item" class="form-control form-control-sm" [(ngModel)]="p.value" name="value"></ngx-tags-input>
                                        <select *ngIf="p.type=='select'" class="form-control form-control-sm" name="value" [(ngModel)]="p.value">
                                            <option *ngFor="let o of p.params" value="{{o.value}}">{{o.label}}</option>
                                        </select>                                    
                                        <table *ngIf="p.type=='table'" class="table table-nowrap table-sm table-head-fixed table-hover m-0 text-sm border">
                                            <thead class="">
                                                <th *ngFor="let f of p.fields">{{f.label}}</th>
                                                <th><button type="button" class="btn btn-xs btn-outline-success btn-block" (click)="addTableRecord(p);"><i class="fa fa-plus mr-2"></i>Aggiungi</button></th>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let v of p.value">
                                                    <td *ngFor="let f of p.fields">
                                                        <input class="form-control form-control-sm" type="text" name="{{f.name}}" [(ngModel)]="v[f.name]"/>
                                                    </td>
                                                    <td>
                                                        <button type="button" class="btn btn-xs btn-outline-danger btn-block" (click)="removeTableRecord(p,v);"><i class="fa fa-trash mr-2"></i>Elimina</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                          </tbody>
                        </table>
                    </div>
                    <!--
                    <ng-container *ngFor="let p of selectedModule.params">
                        <ng-container *ngIf="p.type=='separator'">
                            <div class="col-12 mt-2 bg-light text-gray">
                                <b>{{p.label}}&ensp;</b>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="p.type!='separator'">
                            <div  class="col-2"   [class.col-3]="p.type=='text'" [class.col-12]="p.type=='table'">
                                <small>{{p.label}}&ensp;</small>
                                <div class="input-group input-group-sm" *ngIf="p.type=='type'">
                                    <input type="number" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                    <div class="input-group-append">
                                        <button class="btn btn-default" (click)="searchType(p)"><i class="fa fa-search"></i></button>
                                    </div>
                                </div>
                                <div class="input-group input-group-sm" *ngIf="p.type=='notification'">
                                    <input type="number" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                    <div class="input-group-append">
                                        <button class="btn btn-default" (click)="searchNotification(p)"><i class="fa fa-search"></i></button>
                                    </div>
                                </div>
                                <input *ngIf="p.type=='number'" type="number" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                <input *ngIf="p.type=='text'" type="text" class="form-control form-control-sm" name="value" [(ngModel)]="p.value" />
                                <select *ngIf="p.type=='boolean'" class="form-control form-control-sm" name="value" [(ngModel)]="p.value">
                                    <option value="true">Si</option>
                                    <option value="false">No</option>
                                </select>
                                <ngx-tags-input *ngIf="p.type=='multiple'" displayField="item" class="form-control form-control-sm" [(ngModel)]="p.value" name="value"></ngx-tags-input>
                                <select *ngIf="p.type=='select'" class="form-control form-control-sm" name="value" [(ngModel)]="p.value">
                                    <option *ngFor="let o of p.params" value="{{o.value}}">{{o.label}}</option>
                                </select>
                                
                                <table *ngIf="p.type=='table'" class="table table-nowrap  table-sm table-head-fixed table-hover m-0 text-sm">
                                    <thead>
                                        <th *ngFor="let f of p.fields">{{f.label}}</th>
                                        <th><button type="button" class="btn btn-xs btn-success float-right" (click)="addTableRecord(p);"><i class="fa fa-plus mr-2"></i>Aggiungi</button></th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let v of p.value">
                                            <td *ngFor="let f of p.fields">
                                                <input class="form-control form-control-sm" type="text" name="{{f.name}}" [(ngModel)]="v[f.name]"/>
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-xs btn-danger float-right" (click)="removeTableRecord(p,v);"><i class="fa fa-trash-alt mr-2"></i>Elimina</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </ng-container>
                -->
                </div>

                <!-- 
                <div class="row mt-2" *ngIf="user.role=='superuser'">
                    <div class="col-12" >
                        <button class="btn btn-xs btn-secondary" (click)="enable_edit_params=true">Abilita modifiche parametri</button>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="enable_edit_params && isArray(selectedModule.params)">
                    <div class="col-12">
                        <json-editor [data]="selectedModule.params" (change)="json_params=$event"></json-editor>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-xs" style="background-color: #3883fa;" (click)="selectedModule.params=json_params">Applica</button>
                
                    </div>
                </div>
                
                <div class="row mt-4" *ngIf="user.role=='superuser'">
                    <div class="col-12" >
                        <button class="btn btn-xs float-right" *ngIf="!enable_edit_params" (click)="enable_edit_params=true">Modifica parametri</button>
                    </div>
                    <div class="col-12" *ngIf="enable_edit_params">
                        <label>Parametri</label>
                        <json-editor [data]="selectedModule.params" (change)="json_params=$event"></json-editor>
                        <button class="btn btn-xs text-white" style="background-color: #3883fa;" (click)="selectedModule.params=json_params;enable_edit_params=false">Applica modifiche</button>
                    </div>
                </div>
                -->

            <div class="row mb-4" *ngIf="user.role=='superuser'">                    
                <div class="col-12">
                    <h5>Only for SuperUser</h5>
                    <h6>
                        <span style="color: #3883fa;">Visualizzatore JSON</span>
                        <button class="btn btn-xs text-white float-right" style="background-color: #3883fa;" (click)="selectedModule.params=json_params">Applica</button>
                    </h6>
                    <json-editor [data]="selectedModule.params" (change)="json_params=$event"></json-editor>
                    <br>
                    <button class="btn btn-outline-secondary mr-1" (click)="generateManifest()"><i class="fa fa-plus-square mr-2"></i>Crea Manifest per il modulo</button>
                    <button class="btn btn-outline-secondary" (click)="updateDBModule()"><i class="fa fa-sync-alt mr-2"></i>Aggiorna le tabelle del modulo</button>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-success" data-dismiss="modal" (click)="confirmRule()"><i class="fas fa-save mr-2"></i>Salva</button>
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Annulla</button>
            </div>
        </div>
    </div>
</div>


<ng-template #listModules>
    <div class="modal-header">
        Aggiungi modulo
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="closeListModules()" >
              <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body" style="max-height:80vh; overflow-y:auto">
        <table class="table table-sm mb-0">
            <thead>
                <th>Titolo</th>
                <th>Identificativo</th>
                <th></th>
            </thead>
            <tbody>
                <tr *ngFor="let r of mlist">
                    <td><i class="text-primary {{r.icon}} mr-2"></i><b>{{r.label}}</b></td>
                    <td><small><i>{{r.modulename}}</i></small></td>
                    <td class="text-right"><button class="btn btn-success btn-xs" (click)="installModule(r)">Installa <i class="fa fa-chevron-right ml-1"></i></button></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary btn-sm" (click)="closeListModules()"><i class="fas fa-times mr-1"></i>Chiudi</button>
    </div>
</ng-template>